import { useState, useEffect, useRef } from 'react';

function useMounted() {
    const [mounted, setMounted] = useState(false);
    const timerRef = useRef();
    useEffect(() => {
        timerRef.current = setTimeout(() => setMounted(true), 66);

        return () => clearTimeout(timerRef.current);
    }, []);
    return mounted;
}

export default useMounted;
